export const intrusionSensorConfigurationSelector = state => state.entities.intrusionSensorConfigurations;
